import { FlaskConical, ShieldCheck, Clock, AlertTriangle, XCircle, BadgeCheck } from "lucide-react";
import { PRICE_TYPE, VERIFICATION } from "../lib/labels";

const base = "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap";

const PT = {
  FIXED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  FROM: "bg-amber-50 text-amber-800 border-amber-200",
  ESTIMATE: "bg-sky-50 text-sky-800 border-sky-200",
  RANGE: "bg-indigo-50 text-indigo-800 border-indigo-200",
  UNKNOWN: "bg-slate-100 text-slate-700 border-slate-200",
};

export const PriceTypeBadge = ({ type, testid = "price-type-badge" }) => (
  <span className={`${base} ${PT[type] || PT.FIXED}`} data-testid={testid}>{{ ...PRICE_TYPE, UNKNOWN: "Ukendt" }[type] || type}</span>
);

export const FreshnessBadge = ({ date, testid = "freshness-badge" }) => {
  if (!date) return null;
  const days = (Date.now() - new Date(date).getTime()) / 864e5;
  const label = new Date(date).toLocaleDateString("da-DK");
  if (days > 365) return <span className={`${base} bg-red-50 text-red-700 border-red-200`} data-testid={testid}><AlertTriangle className="h-3 w-3" />Forældet pris · {label}</span>;
  return <span className={`${base} ${days > 180 ? "bg-amber-50 text-amber-800 border-amber-200" : "bg-white text-[#52706D] border-[#D2E5E1]"}`} data-testid={testid}><Clock className="h-3 w-3" />Opdateret {label}</span>;
};

const VS = {
  ADMIN_VERIFIED: ["bg-[#E6F4EF] text-[#087F72] border-[#087F72]/30", ShieldCheck],
  CLINIC_CONFIRMED: ["bg-teal-50 text-teal-800 border-teal-200", BadgeCheck],
  UNVERIFIED: ["bg-orange-50 text-orange-800 border-orange-200", Clock],
  OUTDATED: ["bg-slate-100 text-slate-700 border-slate-200", AlertTriangle],
  REJECTED: ["bg-red-50 text-red-700 border-red-200", XCircle],
};

export const VerificationBadge = ({ status, testid = "verification-badge" }) => {
  const [cls, Icon] = VS[status] || VS.UNVERIFIED;
  return (
    <span className={`${base} ${cls}`} data-testid={testid}>
      <Icon className="h-3 w-3" aria-hidden="true" />
      {VERIFICATION[status] || status}
    </span>
  );
};

export const FictionalBadge = ({ testid = "fictional-badge" }) => (
  <span className={`${base} bg-purple-100 text-purple-900 border-purple-300`} data-testid={testid} title="Klinik og priser er opdigtede testdata">
    <FlaskConical className="h-3 w-3" aria-hidden="true" /> Fiktiv testklinik
  </span>
);

export const StatusPill = ({ children, tone = "slate", testid }) => {
  const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    green: "bg-[#E6F4EF] text-[#087F72] border-[#087F72]/30",
    amber: "bg-amber-50 text-amber-800 border-amber-200",
    red: "bg-red-50 text-red-700 border-red-200",
  };
  return <span className={`${base} ${tones[tone]}`} data-testid={testid}>{children}</span>;
};
